<div class="navbar navbar-default navbar-fixed-top" style="width:100%;" role="navigation">
  <header class="header-container">
      <h1 class="logo-wrap">
        <a rel="noopener noreferrer" class="logo" target="_blank" ui-sref="dashboard" href="https://bethematch.org/">
          <img id="btmLogo" alt="[logo]" class="temp-logo" src="images/logo.svg">
        </a>
        <div class="app-name">
            Lab Gateway
            <span  *ngIf="configService.environment.toUpperCase()!='PROD'" >
                <span  *ngIf="configService.environment.toUpperCase()=='PREPROD'" class="prebadge">PRE</span>
                <span  *ngIf="configService.environment.toUpperCase()!='PREPROD'" class="badge">{{configService.environment.toUpperCase()}}</span>
            </span>
        </div>
      </h1>
      <ul class="nav navbar-nav" *ngIf="(isAuthenticated$ | async)?.isAuthenticated">
          <li><a href="{{configService.uploaderUrl}}">Uploader</a></li>
          <li><a style="border-bottom-color: #bdcc42; border-bottom-width:7px;" href="#" id="dashboardTab">Dashboard</a></li>
      </ul>
      <div *ngIf="this.appComponent.isLoggedIn()" class="account-wrap" toggleArrowAnimation toggleClass="arrow-animation">
        <ng-template #logoutPopover>
          <!--
            Note: popover content doesn't seem to respond well to vertical
            padding or margin.  So we need a few "spacer" divs.
          -->
          <div></div><a style="color: #00355E; text-decoration: underline;cursor: pointer;font-weight: bold;" id="logout" (click)="authService.logout()">Global Logout</a><div></div>
        </ng-template>
        <button type="button" id="username" [ngbPopover]="logoutPopover"
          class="btn btn-primary btn-account" placement="bottom-right" container="false" style="width: fit-content !important;" closePopoverOnClickAnywhere>{{ (userdata$ | async)?.userData['name'] }}
          <mat-icon class="icon" aria-hidden="false" aria-label="User">person</mat-icon>
          <span class="custom-arrow"></span>
        </button>
      </div>
  </header>
</div>
